import React, { useMemo } from 'react';
import { Avatar } from 'antd';
import styled from 'styled-components';
import IcEmployee from './IcEmployee';
import icCheck from './MainV2/icons/icCheck.svg';
import { UserOutlined } from '@ant-design/icons';
import shopSelectors from 'services/shop/selectors';

type ILeftTimeTrackerStaffListProps = {
  value?: string;
  onChange?: (value: string) => void;
  textSearch?: string;
};

const LeftTimeTrackerStaffList = ({
  value,
  onChange,
  textSearch,
}: ILeftTimeTrackerStaffListProps) => {
  const _staffListStore = shopSelectors.data.staffs();
  const _mapingAndFilterAnyBody = _staffListStore.map((staff) => ({
    ...staff,
    staffName: staff.firstName,
    staffId: staff.id,
    staffAvatar: staff.urlImage,
  })).filter((staff) => !staff.anyBody);
  const _staffList = useMemo(() => {
    const searchText = textSearch?.toLocaleLowerCase();
    if (!searchText) return _mapingAndFilterAnyBody;
    return _mapingAndFilterAnyBody.filter((staff) => {
      if (staff.staffName?.toLocaleLowerCase()?.includes(searchText)) return true;
      return false;
    });
  }, [_mapingAndFilterAnyBody, textSearch]);

  const handleSelectStaff = (staffId: string) => {
    if (value === staffId) {
      onChange?.('');
    } else {
      onChange?.(staffId);
    }
  };

  return (
    <StaffList>
      <StaffItem $isSelected={value === ''} onClick={() => handleSelectStaff('')}>
        {value === '' && (
          <div className='icon-check'>
            <img src={icCheck} alt='check' />
          </div>
        )}
        <DefaultAvatar $isSelected={value === ''}>
          <IcEmployee />
        </DefaultAvatar>
        <span className='title'>All Staff</span>
      </StaffItem>
      {_staffList.map((staff) => (
        <StaffItem
          key={staff.staffId}
          $isSelected={value === staff.staffId}
          onClick={() => handleSelectStaff(staff.staffId)}
        >
          {value === staff.staffId && (
            <div className='icon-check'>
              <img src={icCheck} alt='check' />
            </div>
          )}
          <Avatar
            size={100}
            src={staff?.staffAvatar || undefined}
            shape='circle'
            icon={<UserOutlined />}
          />
          <span className='title'>{staff.staffName}</span>
        </StaffItem>
      ))}
    </StaffList>
  );
};

export default LeftTimeTrackerStaffList;

const StaffList = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 8px;
  overflow: auto;
  max-height: calc(80vh - 114px);
`;

const StaffItem = styled.div<{ $isSelected?: boolean }>`
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #fff;
  .title {
    color: #1d2129;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
  }
  .icon-check {
    z-index: 1;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 32px;
    height: 32px;
    border-radius: 3px;
    background: #2d6772;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${(props) =>
    props.$isSelected &&
    `
    border-radius: 5px;
    border: 1px solid #ccd4dc;
    background: #c6e9ef;
  `}
`;

const DefaultAvatar = styled.div<{ $isSelected?: boolean }>`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff;
  border-radius: 50%;
  border: 1px solid #ccd4dc;
  box-sizing: border-box;
  ${(props) =>
    props.$isSelected &&
    `
    background: #fff;
  `}
`;
